<div class="main-page-area">
    <div class="main-page-content">
        <eff-step-header
            [ngClass]="{ 'is-step-rejected': pageState.isRejected }"
            [controlGuid]="effectivenessModel.controlGuid"
            [hideSaveButton]="!stepPermissions.isEditAllowed"
            [title]="'effWorkflowSteps.review' | t"
            (onShowInstructions)="toggleInstructions()"
            (onSaveChanges)="saveChanges(true)"
            [showNonOccurrenceWarningArea]="isNonOccurrenceTestPlan"
        >
        </eff-step-header>

        @if (pageState.isRejected) {
            <author-message-box
                [author]="pageState.rejectedBy"
                [authorLabelKey]="pageState.rejectedByRoleKey"
                [message]="pageState.rejectionMessage"
            >
            </author-message-box>
        }

        <eff-checkbox
            class="expand-collapse-all"
            [label]="'effGrid.openAll' | t"
            (modelChange)="expandCollapseAll($event)"
        ></eff-checkbox>

        <div class="d-flex flex-column grid-conclusion-wrapper">
            <div class="main-grid d-flex flex-column">
                @for (viewSample of viewSamples; track viewSample) {
                    <div>
                        <div class="grid-header">
                            <div class="bold-text">{{ 'effGrid.sampleLabel' | t: { name: viewSample.sample.name } }}</div>
                            <eff-inline-text-editor
                                [label]="'effGrid.addSampleRemark' | t"
                                [(model)]="viewSample.sample.remarks"
                                [disabled]="!stepPermissions.isEditSampleRemarkAllowed"
                                (complete)="saveRemarksChange(viewSample.sample)"
                            ></eff-inline-text-editor>
                            @if (viewSample.sample.taskData) {
                                <div
                                    class="task-link-label"
                                    (click)="openTask(viewSample.sample.taskData)"
                                >
                                    <i class="fas fa-regular fa-link-horizontal"></i>
                                    <label>
                                        {{
                                            viewSample.sample.taskData.actionDate | dateFormat
                                        }}</label
                                    >
                                </div>
                            }
                        </div>
                        <eff-table
                            [dataSource]="viewSample.gridDataSource"
                            [columns]="displayedColumns"
                            [tableConfig]="tableConfig"
                            [expandedRowTemplate]="expandedTemplate"
                        >
                            <ng-template #expandedTemplate let-item="item">
                                <div class="grid-expanded-row">
                                    <div class="table-row">
                                        <div class="table-cell documents">
                                            <div class="d-flex flex-column gap-3">
                                                @if (item.noEvidence) {
                                                    <div class="d-flex flex-column gap-2">
                                                        <eff-checkbox
                                                            [disabled]="true"
                                                            [checked]="true"
                                                            [label]="'effGrid.noEvidence' | t"
                                                        ></eff-checkbox>
                                                        <div class="no-evidence-inner">
                                                            @if (
                                                                stepPermissions.evidenceSaveAllowed
                                                            ) {
                                                                <eff-textarea
                                                                    class="grid-textarea-style"
                                                                    [(model)]="
                                                                        item.noEvidenceReason
                                                                    "
                                                                    [bordered]="false"
                                                                    [disabled]="true"
                                                                    uiid="no-evidence"
                                                                    [popupTitle]="'effGrid.commentNoEvidence' | t"
                                                                    [label]="'effGrid.addComment' | t"
                                                                ></eff-textarea>
                                                            }
                                                        </div>
                                                    </div>
                                                }
                                                <documents-list
                                                    class="documets-list-small-droparea"
                                                    [documents]="item.documents"
                                                    [canAdd]="stepPermissions.evidenceSaveAllowed"
                                                    [canEdit]="stepPermissions.evidenceSaveAllowed"
                                                    [canDelete]="
                                                        stepPermissions.evidenceSaveAllowed
                                                    "
                                                    [taskDocuments]="item.taskData?.documents"
                                                    [isSample]="item.isSample"
                                                    (documentsChange)="
                                                        documentsChange($event, item)
                                                    "
                                                ></documents-list>
                                            </div>
                                        </div>
                                        <div class="table-cell tester-comment">
                                            <div class="comment">
                                                <eff-textarea
                                                    class="grid-textarea-style"
                                                    [(model)]="item.commentTester"
                                                    [bordered]="false"
                                                    [disabled]="true"
                                                    uiid="tester-comment"
                                                    [popupTitle]="'effGrid.commentTester' | t"
                                                    [label]="'effGrid.addComment' | t"
                                                ></eff-textarea>
                                            </div>
                                        </div>
                                        <div class="table-cell reviewer-comment">
                                            <div class="tester-comment-inner">
                                                <eff-textarea
                                                    class="grid-textarea-style"
                                                    [(model)]="item.commentReviewer"
                                                    [disabled]="
                                                        !stepPermissions.evidenceSaveAllowed
                                                    "
                                                    uiid="reviewer-comment"
                                                    [popupTitle]="'effGrid.commentReviewer' | t"
                                                    [label]="'effGrid.addComment' | t"
                                                ></eff-textarea>
                                            </div>
                                        </div>
                                    </div>
                                    @if (item.isLateTask) {
                                        <div class="sample-warning completed-later">
                                            <div class="sample-later-warning-text">
                                                {{ 'effTestingReview.controlExecutionLateWarning' | t }}
                                            </div>
                                            <div class="sample-later-warning-text padding-top-8">
                                                {{
                                                    'effGrid.controlExecutionCompletedAt'
                                                    | t: { date: (item.taskData.completedAt | dateTimeFormat) }
                                                }}
                                            </div>
                                        </div>
                                    }
                                    @if (item.isOpenTask) {
                                        <div class="sample-warning not-completed">
                                            <div class="sample-not-completed-warning-text">
                                                {{ 'effTestingReview.controlExecutionNotFinishedWarning' | t }}
                                            </div>
                                        </div>
                                    }
                                </div>
                            </ng-template>
                            <ng-template column-name="name" let-item="item">
                                <div class="d-flex flex-row gap-3 align-items-center">
                                    <div
                                        [ngClass]="{ 'sample-name-cell': item.isSample }"
                                        class="regular-text"
                                    >
                                        {{ (item.isSample ? 'effTestingReview.sample' : 'effTestingReview.step') | t }} {{ item.name }}
                                    </div>
                                    @if (totalDocumentCount(item) > 0) {
                                        <div class="d-flex flex-row align-items-center gap-1">
                                            <eff-icon
                                                class="remark-icon"
                                                icon="attachment_outlined"
                                            ></eff-icon>
                                            <div>({{ totalDocumentCount(item) }})</div>
                                        </div>
                                    }
                                </div>
                            </ng-template>
                            <ng-template column-name="scoreTester" let-item="item">
                                <div class="d-flex flex-row align-items-center status-cell">
                                    <div
                                        class="status-bullet"
                                        [ngClass]="getScoreColor(item)"
                                    ></div>
                                    <div>{{ item.scoreName }}</div>
                                </div>
                            </ng-template>
                            <ng-template column-name="testerComment" let-item="item">
                                @if (!item.IsExpanded && item.commentTester) {
                                    <div>
                                        <eff-icon
                                            class="remark-icon"
                                            icon="comment_outlined"
                                        ></eff-icon>
                                    </div>
                                }
                            </ng-template>
                            <ng-template column-name="reviewerComment" let-item="item">
                                @if (!item.IsExpanded) {
                                    <div>
                                        @if (item.commentReviewer) {
                                            <eff-icon
                                                class="remark-icon"
                                                icon="comment_outlined"
                                            ></eff-icon>
                                        } @else {
                                            <div class="add-comment-label">{{ 'effTestingReview.addComment' | t }}</div>
                                        }
                                    </div>
                                }
                            </ng-template>
                        </eff-table>
                    </div>
                }
            </div>
            <eff-detail-final-conclusion
                [effectivenessModel]="effectivenessModel"
            ></eff-detail-final-conclusion>
        </div>

        @if (stepPermissions.isEditAllowed) {
            <div class="bottom-buttons-wrapper">
                <eff-button
                    [text]="'effTestingReview.reject' | t"
                    size="large-size"
                    class="bottom-button reject-btn"
                    (click)="reject()"
                ></eff-button>

                <eff-button
                    [text]="'effTestingReview.modify' | t"
                    size="large-size"
                    class="bottom-button final-score-modify-btn"
                    (click)="modify()"
                ></eff-button>

                <eff-button
                    [text]="'effTestingReview.accept' | t"
                    size="large-size"
                    class="bottom-button final-score-accept-btn"
                    (click)="accept()"
                ></eff-button>
            </div>
        }
    </div>

    <div class="side-page-area">
        @if (enableAiEvidenceReviewer && stepPermissions.isEditAllowed && !isNonOccurrenceTestPlan) {
            <app-eff-ai-review-info-box [effectivenessGuid]="effectivenessModel.guid"></app-eff-ai-review-info-box>
        }
        <eff-test-instructions-info-box
            [panelOpenState]="true"
            [samples]="samples"
            [effectivenessModel]="effectivenessModel"
        >
        </eff-test-instructions-info-box>
        <eff-evidence-instructions-info-box
            [samples]="samples"
            [instructions]="effectivenessModel.evidenceUploadInstructions"
        >
        </eff-evidence-instructions-info-box>
        <eff-source-document-info-box
            [effectivenessModel]="effectivenessModel"
            [stepPermissions]="stepPermissions"
        ></eff-source-document-info-box>
        <eff-control-info-box [controlGuid]="effectivenessModel.controlGuid"></eff-control-info-box>
    </div>
</div>

<cerrix-slide-over #cerrixSlideOver>
    <ng-template #title>
        <div class="paragraph">
            <div class="header">{{ 'effTestingReview.howToReviewTitle' | t }}</div>
        </div>
    </ng-template>
    <ng-template #content>
        <div class="paragraph">
            <div class="header">{{ 'effTestingReview.howToReviewSection1Header' | t }}</div>
            <div class="content">
                <ol>
                    <li>{{ 'effTestingReview.howToReviewSection1Step1' | t }}</li>
                    <li>
                        {{ 'effTestingReview.howToReviewSection1Step2' | t }}
                    </li>
                    <li>{{ 'effTestingReview.howToReviewSection1Step3' | t }}</li>
                    <li>{{ 'effTestingReview.howToReviewSection1Step4' | t }}</li>
                </ol>
            </div>
        </div>
        <div class="paragraph">
            <div class="header">{{ 'effTestingReview.howToReviewSection2Header' | t }}</div>
            <div class="content">
                <ul>
                    <li [innerHTML]="'effTestingReview.helpRejectItem' | t"></li>
                    <li [innerHTML]="'effTestingReview.helpModifyItem' | t"></li>
                    <li [innerHTML]="'effTestingReview.helpAcceptItem' | t"></li>
                </ul>
            </div>
        </div>
    </ng-template>
</cerrix-slide-over>
